module.exports = __webpack_public_path__ + "media/luxury-2026/twilight-drone-960-2cfa7bd9.jpg";